import { AfterViewInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, Component, EventEmitter, inject, Output, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Mirko3Service } from '../mirko3.service';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfermaComponent } from '../dialog-conferma/dialog-conferma.component';
import { SicotService } from '../sicot.service';
import { User } from '../types/User';

@Component({
  selector: 'app-operatori',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatTableModule, MatButtonModule, CommonModule, MatDatepickerModule, MatProgressBarModule, MatPaginatorModule, MatIconModule],
  providers: [provideNativeDateAdapter()],
  templateUrl: './operatori.component.html',
  styleUrl: './operatori.component.css'
})
export class OperatoriComponent implements AfterViewInit{
  private _qualificheSelezionate: number | undefined;

  @Input() set qualificheSelezionate(value: any[]) {
    this._qualificheSelezionate = value.map(qualifica => qualifica.id)[0];
}
  @Output() operatoreId = new EventEmitter<any[]>();

  ngAfterViewInit() {
    if (this.dataSource)
    this.dataSource.paginator = this.paginator;
  }


  @ViewChild(MatPaginator) paginator: MatPaginator = new MatPaginator(new MatPaginatorIntl(), ChangeDetectorRef.prototype);


  selectedOperatori: any[] = [];
  disponibilitaSessioneUVM: any[] = [];
  userOperatore: Operatore[] = [];

  loadinDisponibilitaUVM: boolean = false;
  filtroDisponibilita: boolean = true;
  sceltaDisponibilita: boolean = false;

  displayedColumns: string[] = ['Nome','Cognome', 'Qualifica', 'action'];
  displayedColumnsDisponibilitaSessioneUVM: string[] = ['data', 'oraInizio', 'oraFine', 'struttura', 'operatoriBreve', 'action2'];
  dataSource: any;
  dataSoruceSelected: any;
  dataSoruceDisponibilitaSessioneUVM: any;
  mostraAggiungi: boolean = true;



  get mostraFiltroDisponibilita() {
    return this.filtroDisponibilita;
  }

  get mostraSceltaDisponibilita() {
    return this.sceltaDisponibilita;
  }

  get mostraCaricamentoDisponibilitaUVM() {
    return this.loadinDisponibilitaUVM;
  }

  constructor(private siCotService: SicotService) {

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    if (this.qualificheSelezionate) {
      console.log('Qualifiche ricevute:', this.qualificheSelezionate);
  } else {
      console.log('Nessuna qualifica ricevuta');
  }
    this.fetchOperatori();
  }

  back() {
    this.sceltaDisponibilita = false;
    this.filtroDisponibilita = true;
  }

  fetchOperatori(): void {
    this.siCotService.getOperatoriByQualifiche(this._qualificheSelezionate).subscribe(
      (data) => {
        this.userOperatore = data;
        console.log("Operatore " + this.userOperatore)
        this.dataSource = new MatTableDataSource<Operatore[]>(data);
        this.dataSource.paginator = this.paginator;
      },
      (error) => {
        console.error('Error fetching Operatori:', error);
      }
    );
  }

  addToSelected(item: any): void {
    this.selectedOperatori.push(item);
    this.dataSoruceSelected = new MatTableDataSource<Operatore[]>(this.selectedOperatori);
    this.mostraAggiungi = false
  }

  svuotaListaOperatori() {
    this.selectedOperatori = [];
    this.dataSoruceSelected = new MatTableDataSource<Operatore[]>(this.selectedOperatori);
    this.mostraAggiungi=true
  }

  rimuoviDaListaOperatoriSelezionate(item: any) {
    console.log(item);
    if (item) {
      const index = this.dataSoruceSelected.data.indexOf(item);
      if (index > -1) {
        this.dataSoruceSelected.data.splice(index, 1);
        this.dataSoruceSelected = new MatTableDataSource(this.dataSoruceSelected.data);
        this.mostraAggiungi=true
      }
    }
  }

  saveOperatori(){
    this.operatoreId.emit(this.selectedOperatori)
  }
}


export interface Qualifica {
  id: number;
  codice: string;
  descrizione: string;
}

export interface Operatore {
  id: string;
  cognome: string;
  nome: string;
  codiceFiscale: string;
  qualifica: Qualifica[];
}







